var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbitrumNova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1218.5",
    style: {
      enableBackground: "new 0 0 1080 1218.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E57310;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M540,75.5c2.9,0,5.8,0.8,8.4,2.2l447.7,258.5c5.2,3,8.4,8.6,8.4,14.5v516.9c0,6-3.2,11.5-8.4,14.5 l-447.7,258.5c-2.5,1.5-5.5,2.2-8.4,2.2c-2.9,0-5.8-0.8-8.4-2.2L83.9,882.3c-5.2-3-8.4-8.6-8.4-14.5V350.8c0-6,3.2-11.5,8.4-14.5 L531.6,77.8C534.2,76.3,537.1,75.5,540,75.5 M540,0c-15.9,0-31.9,4.1-46.2,12.4L46.2,270.8c-28.6,16.5-46.2,47-46.2,80v516.9 c0,33,17.6,63.5,46.2,80l447.7,258.5c14.3,8.2,30.2,12.4,46.2,12.4s31.9-4.1,46.2-12.4l447.7-258.5c28.6-16.5,46.2-47,46.2-80 V350.8c0-33-17.6-63.5-46.2-80L586.2,12.4C571.9,4.1,555.9,0,540,0L540,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.9,344.5h-58.5c-4.4,0-8.3,2.7-9.8,6.9L169.5,867c-1.2,3.4,1.3,7,4.9,7h58.5c4.4,0,8.3-2.7,9.8-6.9 l188.1-515.7C432,348.1,429.5,344.5,425.9,344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.6,544.4c-1.7-4.6-8.1-4.6-9.8,0l-30.4,83.4c-0.8,2.3-0.8,4.8,0,7.2l84.7,232.2c1.5,4.1,5.4,6.9,9.8,6.9 h58.5c3.6,0,6.1-3.6,4.9-7L501.6,544.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M528.1,344.5h-58.5c-4.4,0-8.3,2.7-9.8,6.9L271.8,867c-1.2,3.4,1.3,7,4.9,7h58.5c4.4,0,8.3-2.7,9.8-6.9 l188.1-515.7C534.3,348.1,531.8,344.5,528.1,344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M552.7,404.2c-1.7-4.6-8.1-4.6-9.8,0l-30.4,83.4c-0.8,2.3-0.8,4.8,0,7.2l135.9,372.4c1.5,4.1,5.4,6.9,9.8,6.9 h58.5c3.6,0,6.1-3.6,4.9-7L552.7,404.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M905.6,344.5h-58.5c-4.4,0-8.3,2.7-9.8,6.9L701.5,723.8c-0.8,2.3-0.8,4.8,0,7.2l30.4,83.4 c1.7,4.6,8.1,4.6,9.8,0l168.8-462.8C911.8,348.1,909.2,344.5,905.6,344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M680.8,674.1c1.7,4.6,8.1,4.6,9.8,0l117.7-322.6c1.2-3.4-1.3-7-4.9-7h-58.5c-4.4,0-8.3,2.7-9.8,6.9 l-84.7,232.2c-0.8,2.3-0.8,4.8,0,7.2L680.8,674.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrumNova);
export default __webpack_public_path__ + "static/media/arbitrum-nova.74e383ddae85bf3e6251da6ba342b231.svg";
export { ForwardRef as ReactComponent };